import request from '../network';

export interface TagListParams {
  isShow?: number;
  pageNum?: number;
  pageSize?: number;
  petType?: number;
  tagName?: string;
}

export const getPetTagPageListApi = (data: TagListParams) => {
  return request({
    url: '/member/royalcanin/admin/petTag/getTagPage',
    method: 'POST',
    data,
  });
};

export const addPetTagApi = (data: Record<string, any>) => {
  return request({
    url: '/member/royalcanin/admin/petTag/add',
    method: 'POST',
    data,
  });
};

export const getPetTagDetailApi = (data: { id: number | string }) => {
  return request({
    url: '/member/royalcanin/admin/petTag/details',
    method: 'POST',
    data,
  });
};

export const updatePetTagApi = (data: Record<string, any>) => {
  return request({
    url: '/member/royalcanin/admin/petTag/update',
    method: 'POST',
    data,
  });
};

export const deletePetTagApi = (data: { id: number | string }) => {
  return request({
    url: '/member/royalcanin/admin/petTag/delete',
    method: 'POST',
    data,
  });
};

export const getPetTagDataApi = (data: { id: number | string; petType?: number | '' }) => {
  return request({
    url: '/member/royalcanin/admin/petTag/getTagData',
    method: 'POST',
    data,
  });
};

export const updatePetTagSortApi = (data: { id: number | string; sortNum: number; sortType: 'UP' | 'DOWN' }) => {
  return request({
    url: '/member/royalcanin/admin/petTag/updateSortNum',
    method: 'POST',
    data,
  });
};
